import axios from "axios";
var httpClient = axios.create({
    baseURL: "".concat(process.env.PORTAL_URL, "/api/backenddemo/ipva"),
});
export default httpClient;
